var map = {
	"./4-CN.png": "lZQr",
	"./4-EN.png": "foty"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MqbT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home ^\.\/4\-.*\.png$
// module id = MqbT
// module chunks = 1